import React, { useEffect, useMemo } from "react";
import {
  Box,
  Container,
  Typography,
  CircularProgress,
  Button,
  Stack,
} from "@mui/material";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import { useLocation } from "react-router-dom";

const buildLinks = (search) => {
  const params = search || "";
  const schemeLink = `ekalsutraparentapp://app/easebuzz${params}`;
  const intentLink = `intent://app/easebuzz${params}#Intent;scheme=ekalsutraparentapp;package=com.ekalsutraparentapp;end`;
  return { schemeLink, intentLink };
};

const EasebuzzReturn = () => {
  const location = useLocation();
  const { schemeLink, intentLink } = useMemo(
    () => buildLinks(location.search),
    [location.search]
  );
  const isAndroid =
    typeof navigator !== "undefined" &&
    /Android/i.test(navigator.userAgent || "");
  const primary = isAndroid ? intentLink : schemeLink;
  const secondary = isAndroid ? schemeLink : intentLink;

  useEffect(() => {
    window.location.href = primary;
    const t = setTimeout(() => {
      window.location.href = secondary;
    }, 600);
    return () => clearTimeout(t);
  }, [primary, secondary]);

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: "60vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          py: 6,
          px: 3,
          textAlign: "center",
        }}
      >
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: "50%",
            bgcolor: "primary.main",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 3,
          }}
        >
          <PhoneAndroidIcon sx={{ fontSize: 40, color: "white" }} />
        </Box>

        <Typography variant="h5" fontWeight={600} gutterBottom>
          Payment complete
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Tap the button below to return to the Ekalsutra Parent App and confirm
          your payment.
        </Typography>

        <CircularProgress size={28} sx={{ mb: 3 }} />

        <Stack spacing={1.5} sx={{ width: "100%", maxWidth: 320 }}>
          <Button
            variant="contained"
            href={primary}
            size="large"
            sx={{ textTransform: "none", py: 1.5, fontWeight: 700 }}
          >
            Open Parent App
          </Button>
          <Button
            variant="outlined"
            href={secondary}
            size="large"
            sx={{ textTransform: "none", py: 1.5 }}
          >
            Try alternate open
          </Button>
        </Stack>

        <Typography variant="body2" color="text.secondary" sx={{ mt: 3 }}>
          If the app does not open, switch to Ekalsutra Parent App from recent
          apps — payment will confirm automatically.
        </Typography>
      </Box>
    </Container>
  );
};

export default EasebuzzReturn;
